export default __webpack_public_path__ + "static/media/approveIcon.78c540d1.svg";